import { useI18n } from "../../lib/i18n";
import { ProjectCard } from "../Cards";
import { Reveal, SectionHead } from "../Common";
import { Rail, ViewAll } from "./Kit";

export function Featured({ projects }) {
  const { t } = useI18n();
  if (!projects?.length) return null;
  return (
    <section data-testid="home-featured" className="container-lux py-24">
      <SectionHead eyebrow={t("nav.developments")} title={t("home.featuredDev")} sub={t("home.featuredDevSub")} action={<ViewAll to="/developments" testid="home-developments-view-all" />} />
      <Rail testid="home-featured-rail" className="md:grid-cols-2 lg:grid-cols-3">
        {projects.slice(0, 6).map((p, i) => (
          <Reveal key={p.id} delay={0.06 * i} className={`w-[85%] shrink-0 snap-start md:w-auto ${i === 0 ? "md:col-span-2 lg:row-span-2" : ""}`}>
            <ProjectCard p={p} tall={i === 0} className="h-full" />
          </Reveal>
        ))}
      </Rail>
    </section>
  );
}
